import { render, staticRenderFns } from "./OfertsHotelPays.vue?vue&type=template&id=1b4542c5&scoped=true&"
import script from "./OfertsHotelPays.vue?vue&type=script&lang=js&"
export * from "./OfertsHotelPays.vue?vue&type=script&lang=js&"
import style0 from "./OfertsHotelPays.vue?vue&type=style&index=0&id=1b4542c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4542c5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VIcon,VRow,VTextField,VTooltip})
